import { APP_DISPLAY_NAME } from "platform-common/index"
import style from "../ImageTextSection/ImageTextSection.module.scss"
import Image from "next/image"

const mediaContents = [
  {
    title: (
      <h1>
        <strong className={style.textTitleStyle}>2x</strong> Sourcing Speed & Accuracy
      </h1>
    ),
    content: (
      <>
        <p>
          Spend hours on LinkedIn?
          <br />
          Sourcers making constant mistakes?
        </p>
        <br />
        <p>
          Upload a Job Description and {APP_DISPLAY_NAME}™ analyzes candidates for you with a Match Score over their
          profile.
        </p>
        <br />
        <p>
          Allows for nearly double the amount of profiles a human can analyze in one day - with far less eye strain or
          pattern matching mistakes.
        </p>
        <br />
        <p className="tmb-text-green-600 !tmb-text-[18px]">This feature is totally free w/ unlimited users!</p>
      </>
    ),
    media: (
      <Image
        src="/videos/Tombo-notifications-linkedin.webp"
        alt="Notifications"
        sizes="(max-width: 1700px): 45vw, 800px"
        priority={false}
        width={800}
        height={525}
      />
    ),
  },
  {
    title: <h1>Increase Responses 50%+</h1>,
    content: (
      <>
        <p>
          Out of Inmails?
          <br />
          Have hard to reach candidates?
        </p>
        <br />
        <p>
          {APP_DISPLAY_NAME}™ finds the personal emails & phones of candidates and writes highly personalized emails,
          with two follow up emails, sends text messages and even lets you call candidates from your PC or smartphone
          (with vanity Caller IDs that candidates tend to answer).
        </p>
        <br />
        <p className="tmb-text-green-600 !tmb-text-[18px]">
          At $35/month (cancel anytime) it’s a fraction of the price of legacy databases or non-AI outreach tools.
        </p>
      </>
    ),
    media: (
      <Image
        src="/videos/Tombo-sending-email.webp"
        alt="Sending email"
        sizes="(max-width: 1700px): 45vw, 800px"
        priority={false}
        width={800}
        height={482}
      />
    ),
  },

  {
    title: (
      <h1>
        <strong className={style.textTitleStyle}>2x</strong> Worker Productivity
      </h1>
    ),
    content: (
      <>
        <p>Do your Sourcers & Recruiters work remotely?</p>
        <p>
          <br />
          AI (without invading privacy) can track the activity of each Sourcer & Recruiter down to the tasks and hour -
          nearly doubling the productivity of your workforce.
        </p>
        <br />
        <p>Enjoy the productivity of a 100% in-office team while allowing your staff to work remotely.</p>
        <br />
        <p className="tmb-text-green-600 !tmb-text-[18px]">
          This AI feature will dramatically improve team productivity. Try it free for 30 days!
        </p>
      </>
    ),
    media: (
      <Image
        src="/images/landing/Tombo-qqm.webp"
        alt={`${APP_DISPLAY_NAME} Logo`}
        sizes="(max-width: 1700px): 45vw, 810px"
        priority={false}
        width={810}
        height={524}
      />
    ),
  },
  {
    title: <h1>Who Has Time To Read Every Resume?</h1>,
    content: (
      <>
        <p>Let {APP_DISPLAY_NAME}™ read every resume and stack rank the candidates for you.</p>
        <br />
        <p>Shrink dozens of human hours reading CVs into 15 minutes of automation.</p>
        <br />
        <p>
          Then select the top candidates and automatically send them highly personalized emails with a single click.
        </p>
        <br />
        <p className="tmb-text-green-600 !tmb-text-[18px]">Coming in June of this year for beta testing!</p>
      </>
    ),
    media: (
      <Image
        src="/images/landing/extensionAnalysis.webp"
        alt="LinkedIn extension"
        sizes="(max-width: 1700px): 45vw, 800px"
        priority={false}
        width={644}
        height={656}
      />
    ),
  },
]

export default mediaContents
